import React, { Fragment } from 'react';
const points = [{
  text: 'Sacrifichi i weekend tra PTOF e progettazioni.',
  highlight: 'Sacrifichi i weekend'
}, {
  text: 'Arrivi a casa esausta, ma devi ancora inventare attività per domani.',
  highlight: 'inventare attività'
}, {
  text: 'Ti senti insicura davanti al pentagramma — anche se non sai leggere una nota.',
  highlight: 'anche se non sai leggere una nota'
}, {
  text: "Vuoi canalizzare l'energia degli alunni con ritmo e movimento.",
  highlight: "canalizzare l'energia"
}, {
  text: "Vuoi un programma d'eccellenza da mostrare alla Dirigente.",
  highlight: "programma d'eccellenza"
}, {
  text: 'Sogni una classe che canti, suoni e collabori.',
  highlight: 'canti, suoni e collabori'
}];
const notForYou = ['Cerchi un manuale teorico-accademico per il conservatorio.', 'Non vuoi cambiare il tuo approccio attuale, anche se ti sta esaurendo.', 'Pensi che la musica a scuola sia "una perdita di tempo".'];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-188">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-189"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, transparent 70%)'
    }} data-id="element-190"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-191">
        {/* Eyebrow */}
        <div className="text-center mb-4" data-id="element-192">
          <span className="inline-flex items-center gap-2 text-primary font-bold text-xs sm:text-sm uppercase tracking-wider bg-primary/10 border border-primary/20 px-4 py-1.5 rounded-full" data-id="element-193">
            🎯 Verifica subito
          </span>
        </div>

        {/* Headline */}
        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 text-center tracking-tight" data-id="element-194">
          Questa risorsa è{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-195">
            per te
          </span>{' '}
          se...
        </h2>
        <p className="text-text-sec text-base sm:text-lg text-center mb-12 max-w-2xl mx-auto" data-id="element-196">
          Spunta mentalmente ogni punto. Se ne riconosci{' '}
          <span className="text-text-main font-bold" data-id="element-197">almeno 3</span>, Musica
          Pronta è stato creato esattamente per te.
        </p>

        {/* Points */}
        <div className="space-y-3 sm:space-y-4 mb-10" data-id="element-198">
          {points.map((point, i) => <div key={i} className="flex items-start gap-4 sm:gap-5 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light hover:border-cta-green/40 hover:-translate-y-0.5 transition-all duration-300 group" data-id="element-199">
              <div className="w-8 h-8 rounded-full bg-cta-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-cta-green/40 group-hover:bg-cta-green group-hover:border-cta-green group-hover:scale-110 transition-all shadow-[0_0_12px_rgba(22,199,132,0.3)]" data-id="element-200">
                <span className="text-cta-green group-hover:text-white text-sm font-black transition-colors" data-id="element-201">
                  ✓
                </span>
              </div>
              <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed" data-id="element-202">
                {point.text.split(point.highlight).map((part, j, arr) => <Fragment key={j} data-id="element-203">
                    {part}
                    {j < arr.length - 1 && <span className="text-cta-green font-bold" data-id="element-204">
                        {point.highlight}
                      </span>}
                  </Fragment>)}
              </p>
            </div>)}
        </div>

        {/* Not for you card */}
        <div className="bg-bg-alt/50 border border-badge-red/20 rounded-2xl p-6 sm:p-7 mb-10" data-id="element-205">
          <h3 className="text-text-main font-black text-base sm:text-lg mb-4 flex items-center gap-2" data-id="element-206">
            <span className="text-badge-red" data-id="element-207">⛔</span> Musica Pronta NON è per
            te se...
          </h3>
          <ul className="space-y-2.5" data-id="element-208">
            {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-text-sec text-sm sm:text-base" data-id="element-209">
                <span className="text-badge-red font-bold flex-shrink-0 mt-0.5" data-id="element-210">
                  ✕
                </span>
                <span data-id="element-211">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Commitment closer + soft CTA */}
        <div className="text-center bg-gradient-to-br from-primary/10 to-cta-green/5 border border-primary/30 rounded-2xl p-6 sm:p-8 relative overflow-hidden" data-id="element-212">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(circle at center, rgba(22,199,132,0.08) 0%, transparent 70%)'
        }} data-id="element-213"></div>
          <p className="relative text-text-main text-lg sm:text-xl font-bold leading-relaxed mb-5" data-id="element-214">
            Hai detto <span className="text-cta-green" data-id="element-215">SÌ</span> a 3 o più
            punti?
            <br className="hidden sm:block" data-id="element-216" />
            <span className="text-text-sec font-medium text-base sm:text-lg" data-id="element-217">
              Allora i tuoi prossimi weekend liberi ti aspettano qui sotto.
            </span>
          </p>
          <a href="#pricing" className="relative inline-flex items-center gap-2 text-cta-green font-black text-base sm:text-lg hover:gap-3 transition-all border-b-2 border-cta-green/40 hover:border-cta-green pb-1" data-id="element-218">
            👉 Vedi cosa contiene il Kit →
          </a>
        </div>
      </div>
    </section>;
}